// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from '../../../../components/MDBox';
import MDTypography from '../../../../components/MDTypography';

// Material Dashboard 2 React context
import { useMaterialUIController } from '../../../../context';

function ProjectCard({ name, description, index, updateIndex }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  // Uses callback function to pass the selected index back to the parent component
  // to trigger state change on index variable
  // Created to determine which project will be displayed on the right hand side
  const handleCardClick = () => {
    updateIndex(index);
  }

  return (
    <MDBox
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor="navy"
      borderRadius="lg"
      p={3}
      my={1}
      onClick={handleCardClick}
      sx={{
        '&:hover': {
        transform: "scale(1.05)",
        border: "2px solid #2B5587",
        cursor: 'pointer',
        },
      }}
    >
      <MDBox width="100%" display="flex" flexDirection="column">
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexDirection={{ xs: "column", sm: "row" }}
        >
          <MDTypography variant="body1" fontWeight="medium" textTransform="capitalize">
            {name}
          </MDTypography>
        </MDBox>
        <MDBox mb={1}>
          <MDTypography variant="body2" fontWeight="medium" color="text">
            Description:&nbsp;&nbsp;&nbsp;
          </MDTypography>
          <MDBox mt={1} mb={1}>
            <MDTypography 
              variant="body2" 
              component="p" 
              color="text"
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {description}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

// Typechecking props for the Bill
ProjectCard.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  index: PropTypes.number,
  updateIndex: PropTypes.func,
};

export default ProjectCard;
